import { useEffect, useState } from "react";
import { LGWINDOWCUTOFF } from "../constants";

// used for window size state
export const useIsDesktop = () => {
  const [isDesktop, setDesktop] = useState(window.innerWidth > LGWINDOWCUTOFF);

  useEffect(() => {
    if (window.innerWidth > LGWINDOWCUTOFF) {
      setDesktop(true);
    } else {
      setDesktop(false);
    }

    const updateMedia = () => {
      if (window.innerWidth > LGWINDOWCUTOFF) {
        setDesktop(true);
      } else {
        setDesktop(false);
      }
    };
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  }, []);

  return isDesktop;
};
